<template>
    <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1 8.58301H15"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
        />
        <path
            d="M9 1L16 8.583L9 16.167"
            stroke-width="2"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>

<script>
export default {
  name: 'IconRight',
};
</script>
